import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { fetchPageData } from "../endpoint/pageApi";
import MainLayout from "../layouts/MainLayout";
import { MarkdownComponent } from "../layouts/FormLayout";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../utils/mediaBreakpoints";

const MainCookiePolicyPage = ({ data }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const scrollElement = scrollContainerRef.current;
    if (scrollElement && window.bootstrap) {
      new window.bootstrap.ScrollSpy(scrollElement, {
        target: "#list-example",
        offset: 0,
      });
    }
  }, []);

  const handleScrollClick = (e, id) => {
    e.preventDefault();
    const targetElement = document.getElementById(id);
    const scrollContainer = scrollContainerRef.current;

    if (targetElement && scrollContainer) {
      const offsetTop = targetElement.offsetTop;
      scrollContainer.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };

  const formattedDate = new Date(data?.updatedAt).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return (
    <>
      <div
        className="container-fluid m-0 p-0"
        id="main-container"
        style={{ backgroundColor: " #090D24" }}
      >
        <div className="container px-0 contwidth position-relative">
          <div className="row px-0">
            <div className="col-12">
              <p
                className="fw900  text-white pt-2"
                style={{
                  fontSize: _576
                    ? "30px"
                    : _768
                    ? "40px"
                    : _992
                    ? "49px"
                    : _1200
                    ? "54px"
                    : _1400
                    ? "59px"
                    : _1600
                    ? "64px"
                    : _1700
                    ? "79px"
                    : _1800
                    ? "89px"
                    : "90px",
                }}
              >
                {data?.privacy_header?.heading}
              </p>
              <p
                className="text-white fw400 pt-1 pb-2"
                style={{
                  fontSize: _576
                    ? "10px"
                    : _768
                    ? "12px"
                    : _992
                    ? "13px"
                    : _1200
                    ? "14px"
                    : _1400
                    ? "14px"
                    : _1600
                    ? "15px"
                    : _1700
                    ? "15px"
                    : _1800
                    ? "20px"
                    : "20px",
                }}
              >
                Last updated: <span>{formattedDate}</span>
              </p>
              <p
                dangerouslySetInnerHTML={{
                  __html: data?.privacy_header?.description.replace(
                    /\n/g,
                    "<br/>"
                  ),
                }}
                className="text-white fw-300 pb-3 lh-1"
                style={{
                  fontSize: _576
                    ? "12px"
                    : _768
                    ? "13px"
                    : _992
                    ? "16px"
                    : _1200
                    ? "16px"
                    : _1400
                    ? "18.5px"
                    : _1600
                    ? "21px"
                    : _1700
                    ? "21px"
                    : _1800
                    ? "26px"
                    : "26px",
                  lineHeight: "1.8rem",
                }}
              ></p>
            </div>

            {/* <div className="pb-5" id="scroll-container">
              <div className="row pt-3 pb-5">
                <div className="col-md-4">
                  <p
                    className="fw700 text-white"
                    style={{
                      fontSize: _576
                        ? "20px"
                        : _768
                        ? "20px"
                        : _992
                        ? "20px"
                        : _1200
                        ? "25px"
                        : _1400
                        ? "30px"
                        : _1600
                        ? "35px"
                        : _1700
                        ? "35px"
                        : _1800
                        ? "40px"
                        : "40px",
                    }}
                  >
                    Table of Contents
                  </p>
                  <div
                    id="list-example"
                    className="list-group text-white fw700 fs26"
                  >
                    {data?.privacy_header?.table_of_contents?.map(
                      (item, index) => (
                        <a
                          key={index}
                          className="text-white textdecnone list-group-item bg-transparent border-0 p-0"
                          href={`${item?.target}`}
                          style={{
                            fontSize: _576
                              ? "12px"
                              : _768
                              ? "12px"
                              : _992
                              ? "17px"
                              : _1200
                              ? "17px"
                              : _1400
                              ? "19px"
                              : _1600
                              ? "20px"
                              : _1700
                              ? "21px"
                              : _1800
                              ? "26px"
                              : "26px",
                          }}
                        >
                          {index + 1 + ". " + item?.title}
                        </a>
                      )
                    )}
                  </div>
                </div>

                <div className="col-md-8 border-3 border-start ps-5 position-">
                  <div
                    className="position-relative pe-5"
                    data-bs-spy="scroll"
                    data-bs-target="#list-example"
                    data-bs-offset="100"
                    tabIndex="0"
                    style={{
                      overflowX: "hidden",
                      overflowY: "auto",
                      height: "600px",
                      scrollBehavior: "smooth",
                      // scrollbarWidth: "none",
                      // msOverflowStyle: "none",
                    }}
                  >
                    {data?.privacy_header?.privacy_details?.map(
                      (item, index) => (
                        <div
                          key={item?.content_Id}
                          id={item?.content_Id}
                          className="text-white position-relative"
                        >
                          <p className="fw700 fs40">{`${index + 1}. ${
                            item?.title
                          }`}</p>
                          <p
                            className="fw300 fs26"
                            style={{ lineHeight: "1.5rem" }}
                          >
                            <MarkdownComponent markdown={item?.description} />
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div> */}
            <div className="pb-5" id="scroll-container">
              <div className="row pt-3 pb-5">
                <div className="col-md-4">
                  <p
                    className="fw700 text-white"
                    style={{
                      fontSize: _576
                        ? "20px"
                        : _768
                        ? "20px"
                        : _992
                        ? "20px"
                        : _1200
                        ? "25px"
                        : _1400
                        ? "30px"
                        : _1600
                        ? "35px"
                        : _1700
                        ? "35px"
                        : _1800
                        ? "40px"
                        : "40px",
                    }}
                  >
                    Table of Contents
                  </p>

                  <div
                    id="list-example"
                    className="list-group text-white fw700 fs26"
                  >
                    {data?.privacy_header?.table_of_contents?.map(
                      (item, index) => (
                        <a
                          key={index}
                          href={item?.target}
                          onClick={(e) =>
                            handleScrollClick(e, item?.target?.replace("#", ""))
                          }
                          className="text-white textdecnone list-group-item bg-transparent border-0 p-0"
                          style={{
                            fontSize: _576
                              ? "12px"
                              : _768
                              ? "12px"
                              : _992
                              ? "17px"
                              : _1200
                              ? "17px"
                              : _1400
                              ? "19px"
                              : _1600
                              ? "20px"
                              : _1700
                              ? "21px"
                              : _1800
                              ? "26px"
                              : "26px",
                          }}
                        >
                          {index + 1 + ". " + item?.title}
                        </a>
                      )
                    )}
                  </div>
                </div>

                <div className="col-md-8 border-3 border-start ps-5">
                  <div
                    ref={scrollContainerRef}
                    className="position-relative pe-5"
                    data-bs-spy="scroll"
                    data-bs-target="#list-example"
                    data-bs-offset="100"
                    tabIndex="0"
                    style={{
                      overflowY: "auto",
                      height: "600px",
                      scrollBehavior: "smooth",
                    }}
                  >
                    {data?.privacy_header?.privacy_details?.map(
                      (item, index) => (
                        <div
                          key={item?.content_Id}
                          id={item?.content_Id}
                          className="text-white position-relative"
                        >
                          <p className="fw700 fs40">{`${index + 1}. ${
                            item?.title
                          }`}</p>
                          <p
                            className="fw300 fs26"
                            style={{ lineHeight: "1.5rem" }}
                          >
                            <MarkdownComponent markdown={item?.description} />
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const CookiePolicy = () => {
  const [pageData, setPageData] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchPageData(
      "pages?filters[slug][$eq]=cookie-policy",
      setPageData,
      setLoader
    );
  }, []);
  return (
    <MainLayout loader={loader}>
      <div className="container-fluid  p-0 overflow-x-hidden">
        <MainCookiePolicyPage data={pageData} />
      </div>
    </MainLayout>
  );
};

export default CookiePolicy;
